import React, { useState, useEffect } from "react";
import { Card, Button } from "react-bootstrap";
import axios from "axios";
import { API } from "../../api";
import { connect } from "react-redux";

function ShowAddress(props) {
  const [address, setAddress] = useState([]);
  useEffect(() => {
    if (props.token) {
      axios(`${API}addresses/`, {
        headers: { Authorization: `Bearer ${props.token}` },
      })
        .then((res) => setAddress(res.data))
        .catch((err) => {
          console.log(err.response.data);
        });
    }
  }, [props.token]);

  const handelDelete = (id) => {
    axios
      .delete(`${API}addresses/${id}/`, {
        headers: { Authorization: `Bearer ${props.token}` },
      })
      .then((res) => {
        setAddress(address.filter((item) => item.id !== id));
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };
  return (
    <div>
      {address.length > 0 ? (
        address.map((item, i) => {
          return (
            <div key={item.id + i} className="col-lg-6 mb-3">
              <Card>
                <Card.Body>
                  <Card.Title>Address {i + 1} :-</Card.Title>
                  <p className="m-0">
                    <span className="fw-bold">Name : </span>
                    {item.first_name} {item.last_name}
                  </p>
                  <p className="m-0">
                    <span className="fw-bold">Phone : </span> {item.phone}
                  </p>
                  <p className="m-0">
                    <span className="fw-bold">Address : </span> {item.address}
                  </p>
                  <p className="m-0">
                    <span className="fw-bold">Landmark : </span> {item.landmark}
                  </p>
                  <p className="m-0">
                    <span className="fw-bold">City : </span> {item.city}
                  </p>
                  <p className="m-0">
                    <span className="fw-bold">Zipcode : </span> {item.zipcode}
                  </p>
                  <p>
                    <span className="fw-bold">State : </span> {item.state}
                  </p>
                  <div>
                    <Button
                      variant="dark"
                      onClick={() => {
                        props.history.push(`/profile/address/${item.id}`);
                      }}
                    >
                      Edit
                    </Button>
                    <Button
                      variant="dark"
                      className="ms-4"
                      onClick={() => {
                        handelDelete(item.id);
                      }}
                    >
                      Delete
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </div>
          );
        })
      ) : (
        <div>
          <p>
            You Don't Have Any Saved Address. Please Click On The Profile To Add
            Address
          </p>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.userDetails.token,
  };
};

export default connect(mapStateToProps)(ShowAddress);
